import i18n from "../i18n/index"
// 商品属性
export const ItemAttr = {
    import: i18n.t(`utils.enum.进口`),
    domestic: i18n.t(`utils.enum.国产`)
}

//成员类型
export const OperatorUserType = {
    1: i18n.t(`utils.enum.内部员工`),
    2: i18n.t(`utils.enum.团队`),
    3: i18n.t(`utils.enum.客户`),
}

//车载设备类型
export const VehicleEquipmentType = {
    wangwei: i18n.t(`utils.enum.万位`),
    "streaming-vip": i18n.t(`utils.enum.雄聚科技`)
}

//账目分类属性

export const AccountClassStatus = {
    1:i18n.t(`utils.enum.支出`),
    2:i18n.t(`utils.enum.收入`),
    3:i18n.t(`utils.enum.成本`)
}

//结算方式
export const settlementMethodEmun = {
    point:i18n.t(`utils.enum.点位结算`),
    share_ratio:i18n.t(`utils.enum.分成比例结算`),
    quota:i18n.t(`utils.enum.定额结算`),
    work_hour:i18n.t(`utils.enum.工时结算`)
}

//团队结算开票状态
export const teamInvoiceStatus = {
    1: i18n.t(`utils.enum.未开票`),
    2: i18n.t(`utils.enum.开票中`),
    3: i18n.t(`utils.enum.已开票`)
}

//团队结算开票状态
export const teamSettlementStatus = {
    1: i18n.t(`utils.enum.未结算`),
    2: i18n.t(`utils.enum.已结算`)
}

//维修物料商品状态
export const MaintainOrdeStatus = {
    tobe_picked: i18n.t(`utils.enum.待领取`),
    picked: i18n.t(`utils.enum.已领料`),
    returning: i18n.t(`utils.enum.退料中`),
    returned: i18n.t(`utils.enum.已退料`),
}

//维修物料商品状态
export const MaintainOrdeReturnStatus = {
    tobe_review: i18n.t(`utils.enum.待审核`),
    reject: i18n.t(`utils.enum.驳回`),
    pending_storage: i18n.t(`utils.enum.待入库`),
    success: i18n.t(`utils.enum.已入库`),
}


//维修物料商品状态
export const MaintainOrdeReturnListStatus = {
    processing: i18n.t(`utils.enum.进行中`),
    completed: i18n.t(`utils.enum.已完成`)
}


//订单退单状态
export const OrderReturnStatus = {
    pending_review:i18n.t(`utils.enum.待审核`),
    billed:i18n.t(`utils.enum.已开单`),
    in_stock:i18n.t(`utils.enum.已入库`),
    settled:i18n.t(`utils.enum.已结算`)
}

//订单退单状态
export const BigBagBillingMethod = {
    mileage:i18n.t(`utils.enum.里程`),
    tonnage:i18n.t(`utils.enum.吨位`),
    cube:i18n.t(`utils.enum.立方`),
    kwh:i18n.t(`utils.enum.千瓦时`)
}

// 预约单单据类型
export const appointmentSourceType = {
    zf:i18n.t(`utils.enum.采埃孚工单`)
}

// 预约单单据状态
export const appointmentOrderStatus  = {
    tobe_transferred: i18n.t(`utils.enum.待转接`),
    transferred: i18n.t(`utils.enum.已转接`),
    cancelled: i18n.t(`utils.enum.已取消`),
}


// 车型属性
export const vehicleDomestic = {
    0: i18n.t(`utils.enum.进口`),
    1: i18n.t(`utils.enum.国产`),
}

